import React, { useEffect, useRef, useState } from "react";
import { aspectRatio } from "../../../../../../../common/parameters";
import ScoresTab from "../../../../../../pages/plan/ScoresTab";
import { IProps } from "./interfaces";

import { Container } from "./styles";

const ScoreEditor = ({ data, plan, taskIndex }: IProps) => {
    const { scores = [] } = data;
    const [contextScale, setContextScale] = useState(0);
    const ref = useRef<HTMLDivElement>(null);
    const getScale = () => {
        const { width } = ref.current!.getBoundingClientRect();
        if (!width) {
            setTimeout(getScale, 50);
            return;
        }
        setContextScale(width / aspectRatio.width);
    }
    useEffect(() => {
        getScale()
    }, []);
    return (
        <Container ref={ref}>
            {!!contextScale && (
                <ScoresTab
                    plan={plan}
                    subScore={{
                        scores,
                        taskIndex,
                    }}
                    contextScale={contextScale}
                />
            )}
        </Container>
    );
};

export default ScoreEditor;
